import { ActionButton } from '@emerald-works-nova/components'
import { useEvent } from '@emerald-works/react-event-bus-client'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BannerStatic } from '../../../components'
import { UserListSlice } from '../../../reducers'

const RestoreButton = () => {
  const { subscription } = useSelector(UserListSlice.selectors.selectUser)
  const dispatch = useDispatch()
  const [updateSubscription] = useEvent([
    {
      eventName: 'subscriptionUpdate',
      onSuccess: payload => {
        dispatch(UserListSlice.actions.setUserSubscription(payload))
        BannerStatic.show({ label: 'User subscription restored' })
      },
      onError: e => {
        console.error(
          "Error occured while attempting to restore the user's subscription",
          e
        )
        BannerStatic.show({
          label:
            e.message ||
            "Error occured while attempting to restore the user's subscription",
          isError: true
        })
      }
    }
  ])

  const loading = updateSubscription.isWorking

  const handleRestore = () => {
    updateSubscription.trigger({
      subscriptionId: subscription.uuid,
      suspension: {
        cycles: 0,
        note: 'User subscription restored'
      }
    })
  }

  return (
    <ActionButton
      variant='secondary'
      onClick={handleRestore}
      isWorking={loading}
      disabled={loading}
      dataTest='restore-subscription-button'
    >
      Restore subscription
    </ActionButton>
  )
}

export default RestoreButton
